import axios from 'axios';
import { API_BASE_URL } from '@config';

export const GET_SESSION_CAPACITY = 'GET SESSION CAPACITY';
export const GET_SESSION_CAPACITY_SUCCESS = 'GET SESSION CAPACITY SUCCESS';
export const GET_SESSION_CAPACITY_ERROR = 'GET SESSION CAPACITY ERROR';

export function getSessionCapacity() {
    // Get token from localStorage like in user.actions.js
    const token = window.localStorage.getItem('token');
    
    // Create request with proper authorization header
    const request = axios.get(`${API_BASE_URL}/api/sessions/capacity`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return dispatch => {
        dispatch({
            type: GET_SESSION_CAPACITY
        });

        request
            .then(response => {
                dispatch({
                    type: GET_SESSION_CAPACITY_SUCCESS,
                    payload: response.data
                });
            })
            .catch(error => {
                console.error('Error fetching session capacity:', error);
                dispatch({
                    type: GET_SESSION_CAPACITY_ERROR,
                    payload: error
                });
            });
    };
}
